export default __webpack_public_path__ + "static/media/sketch-01.a6abd690.jpg";